import { Inject } from '@odinjs/odin';

import { Endpoint, Route } from '@philips-emr/hpms-stipulator-commons';
import { PanelAPI, TextAPI } from '@philips-emr/tws-components';
import Controller, { OnClick, OnMount } from '@philips-emr/tws-core/lib/client';
import { MountEvent } from '@philips-emr/tws-core/lib/component/types';
import { HttpService, msg } from '@philips-emr/tws-core/lib/services';
import { format } from '@philips-emr/tws-core/lib/services/model-service';
import { applicationContext } from '@philips-emr/tws-foundation';
import { isEmptyOrBlankString } from '@philips-emr/tws-utils';

import BaseController from '../BaseController';

interface Usuario {
  nmPessoaUsuario: string;
  cdPessoaFisica: string;
  dsEmail: string;
  dtUltimoAcesso: string;
}

@Controller({ fragment: 'meus-dados' })
export default class MeusDadosController extends BaseController {

  @Inject('text-ultimo-acesso')
  private ultimoAcessoText: TextAPI;

  @OnClick({ target: 'link-alterar-senha' })
  onClickAlterarSenha(): void {
    this.historyService.push(Route.ALTERAR_SENHA);
  }

  @OnClick({ target: 'link-privacidade' })
  onClickPrivacidade(): void {
    applicationContext.redirect(Route.PRIVACIDADE, { });
  }

  @OnMount('panel-ultimo-acesso')
  public onMountPlanelUltmioAcesso(event: MountEvent): void {
    const api = event.target as unknown as PanelAPI;
    const setVisibility = (visibility: boolean): void => api.setVisible(visibility);

    void HttpService.get<Usuario>(Endpoint.GET.DASHBOARD_USUARIO)
      .then(({ body: usuario }) => {
        let visibility = false;

        if (usuario && !isEmptyOrBlankString(usuario.dtUltimoAcesso)) {
          visibility = true;

          const menssage = msg('stipulator.ola-usuario-ultimo-acesso')
            .replace('#@NM_USUARIO#@', usuario.nmPessoaUsuario)
            .replace('#@DT_ULTIMO_ACESSO#@', format('date', usuario.dtUltimoAcesso, { type: 'timestamp' }));

          this.ultimoAcessoText.setValue(menssage);
        }

        setVisibility(visibility);
      }).catch(() => setVisibility(false));
  }
}
